import { useCallback, useState } from 'react';
import { Box, PasswordField, Button, TextField, Alert } from '@doist/reactist';
import logo from '../../logo-wide.png';

import '@doist/reactist/styles/alert.css';
import { useMenu } from '../../hooks/useMenus';

function Signup() {
    const [ , , menuId ] = window.location.pathname.split('/');
    const { menu, isLoading, isError } = useMenu(menuId);

    console.log('menuId:', menuId, menu, isLoading, isError);

    if (isLoading) {
        return null;
    }

    return (
        <Box display="block" padding="xxlarge" style={{ width: '90%', margin: '50px auto', border: '1px solid #ccc', boxShadow: "5px 5px 16px 0px rgba(0,0,0,0.29)" }}>
            <div className="Logo public">
                <img src={logo} alt="Company Logo" className="logoImage" />
            </div>
            <img className="publicImage" src="https://joyfoodsunshine.com/wp-content/uploads/2019/02/pizza-casserole-recipe-4.jpg" alt="Pizza Cassarole" />
            <h1>Pizza Cassarole</h1>
            <span>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer semper nunc et lacinia tristique. Ut scelerisque ligula at mi dignissim elementum. Donec vitae tellus tellus. Ut ullamcorper dolor purus, nec dignissim nunc vehicula nec. Etiam vitae viverra ligula, eu ornare turpis. Sed facilisis leo at metus tristique suscipit. Donec non risus rhoncus, tincidunt enim eu, sagittis libero.</p>

                <p>Duis nec leo hendrerit, pharetra tortor ornare, pulvinar odio. Ut nec aliquet justo. Morbi vehicula, erat eget rhoncus lobortis, tortor justo viverra purus, sed laoreet lectus urna ac dolor. Mauris sem elit, aliquam non porta feugiat, lacinia eget metus. Nulla viverra libero sit amet ligula ornare, auctor ultricies sapien feugiat. Suspendisse suscipit dignissim ipsum, vitae feugiat velit imperdiet laoreet. Fusce tempor ligula vitae pellentesque blandit. Morbi consequat, turpis eu tempus efficitur, neque massa porttitor nisi, vel congue lectus orci eu augue.</p>
            </span><br style={{ clear: 'both' }} />

            <h2 style={{ whiteSpace: 'nowrap' }}>Order Now</h2>
            <form onSubmit={(evt) => {evt.preventDefault();console.log('submit');}}>
                {<><Alert tone="critical">Login Error</Alert><br /></>}
                <TextField
                    label="Email Address"
                    maxWidth="small"
                    message=""
                    placeholder="Enter your email"
                    tone="neutral"
                    variant="default"
                    value={''}
                    onChange={(evt) => { console.log('text') }}
                    /><br />
                <PasswordField
                    label="Password"
                    maxWidth="small"
                    message=""
                    placeholder="Enter your password"
                    value={''}
                    onChange={(evt) => { console.log('text') }}
                /><br />
                <Button type='submit' variant="primary">Login</Button>
            </form>
        </Box>
    );
};

export default Signup;
